module.exports = __webpack_public_path__ + "static/banner-f6038268d6264d841a118ae22c2ef27e.png";